module.exports = __webpack_public_path__ + "static/360tour-fe3abe6913ddc6f97ad436cb8c3bb56c.webp";